import React from 'react';
import { Box, Body, Heading } from '@hover/blueprint';

interface Props {
  content: React.ReactNode;
  stepNumber: number;
  heading: string;
}

const Content: React.FC<Props> = ({ content, stepNumber, heading }) => (
  <Box flexDir="column" maxW={{ base: 'auto', desktop: '500px' }}>
    <Body
      letterSpacing="0.15em"
      isBold
      size={300}
      mb={400}
      textTransform="uppercase"
      color="brandOrange.500"
    >
      Step {stepNumber}
    </Body>
    <Heading
      isLight
      marginBottom={{ base: 400, tablet: 400 }}
      size={{ base: 500, tablet: 600 }}
    >
      {heading}
    </Heading>
    {content}
  </Box>
);

export default Content;
